module.exports = __webpack_public_path__ + "static/3_2_Bayes-Rule_2_DE-4938ba15939ad53fa09ea10f9e4319b1.svg";